/**
 * Returns the symbol or suffix for a given currency code.
 * @param {string} currencyCode - e.g. "INR", "USD", "EUR", "ZiG"
 * @param {"prefix" | "suffix"} position - default "prefix"
 * @returns {string} Currency symbol or suffix text.
 */
export const getCurrencySymbol = (currencyCode, position = "prefix") => {
    const symbols = {
        INR: { prefix: "₹", suffix: "" },
        USD: { prefix: "$", suffix: "" },
        EUR: { prefix: "€", suffix: "" },
        GBP: { prefix: "£", suffix: "" },
        JPY: { prefix: "¥", suffix: "" },
        ZiG: { prefix: "", suffix: " ZiG" }, // Example of suffix-style currency
    };

    const currency = symbols[currencyCode] || { prefix: "", suffix: "" };
    return position === "suffix" ? currency.suffix : currency.prefix;
};
